import React, { useState, useEffect } from "react";
import { Avatar, Backdrop, CircularProgress, Link, Paper, Stack, Tooltip } from "@mui/material";
import { DeleteRounded, EditRounded, Star } from "@mui/icons-material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { productDetailApi, productAddImageApi } from "store/api";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import { Card, CardContent, Typography, Button, Chip, Grid, Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { deleteProductApi } from "store/api";
import FilterList from "./FilterList";
import "swiper/css";

// import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import "./styles.css";

// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import AddImageDialog from "./AddImageDialog";
import Success from "components/Success";
import axios from "axios";
import UpdateImageDialog from "./UpdateImageDialog";
import { productUpdateBasicDetailsApi } from "store/api";
import EditReviewForm from "./editReviewForm";
import { productUpdateReviewApi } from "store/api";
import BoughtTogether from "./BoughtTogether";
import Grid2 from "@mui/material/Unstable_Grid2";

const ProductDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [filter, setFilter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [addingOptionId, setAddingOptionId] = useState(null);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [updateOpen, setUpdateOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const productId = location.state?.productId;
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [addImage, setAddImage] = useState("");
  const [product, setProduct] = useState(null);
  const [filters, setFilters] = useState([]);
  const [images, setImages] = useState([]);
  const [updateReviewData, setUpdateReviewData] = useState({});
  const [reviewOpen, setReviewOpen] = useState(false);

  const handleChangeUpdateReview = e => {
    const { value, name } = e.target;
    setUpdateReviewData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    getFilterDetails();
  }, []);

  const getFilterDetails = async () => {
    try {
      const res = await axios.get(`/filter/filter-details?filterId=${filterId}`);
      setFilter(res.data);
    } catch (err) {
      console.error("Error fetching filter:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddOption = async filterOptionId => {
    try {
      setAddingOptionId(filterOptionId);
      await axios.post("/product/add-filter-option-to-product", {
        productId,
        filterOptionId,
        isActive: true,
      });
      alert("Option added successfully");
    } catch (err) {
      console.error("Error adding option:", err);
      alert("Failed to add option");
    } finally {
      setAddingOptionId(null);
    }
  };

  const handleSubmitReview = async e => {
    e?.preventDefault();
    const response = await productUpdateReviewApi(updateReviewData);
    if (response?.success) {
      setMsg("Review update successfully");
      setOpenSuccess(true);
      setSuccess(true);
      getProductDetails();
      handleCloseReview();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpenLoader(false);
  };

  const removeImage = index => {
    setImages(images.filter((_, i) => i !== index));
  };

  const getProductDetails = async () => {
    let data = {
      productId: productId,
    };
    const response = await productDetailApi(data);
    if (response?.success) {
      setProduct(response?.data?.productDetails);
      setFilters(response?.data?.filters);
    }
  };
  const [open, setOpen] = React.useState(false);
  const [manageImageData, setManageImageData] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickOpenUpdate = data => {
    setManageImageData(data);
    setUpdateOpen(true);
  };
  const handleClickOpenReview = data => {
    setUpdateReviewData(data);
    setReviewOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setManageImageData("");
  };
  const handleCloseReview = () => {
    setReviewOpen(false);
    setUpdateReviewData("");
  };
  const handleCloseUpdate = () => {
    setUpdateOpen(false);
  };
  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };
  useEffect(() => {
    if (productId) getProductDetails();
  }, [productId]);
  const [selectedColor, setSelectedColor] = useState("");
  const currentColorData = product?.colors?.find(c => c.colorCode === selectedColor);
  const uploadImage = async (e, action) => {
    e.preventDefault();
    const apiData = {
      productId: product?.productId,
      operation: "add",
    };
    if (action == "update") {
      apiData.operation = "edit";
      apiData.productImageId = manageImageData?.productImageId;
    }
    const response = await productAddImageApi(apiData);
    if (response?.success) {
      let uploadUrl = response?.data;
      const uploadResponse = await axios.put(uploadUrl, addImage?.image, {
        headers: { "Content-Type": addImage?.image?.type },
      });
      if (uploadResponse?.status) {
        setMsg("Image upload successfully");
        setOpenSuccess(true);
        setSuccess(true);
      } else {
        setOpenSuccess(true);
        setSuccess(false);
        setMsg("Something went wrong in upload image. Please try again later.");
      }
      getProductDetails();
      setOpen(false);
      handleCloseUpdate();
    }
  };

  const deleteImage = async e => {
    const apiData = {
      productId: product?.productId,
      productImageId: e?.productImageId,
      operation: "delete",
    };
    const response = await productAddImageApi(apiData);
    if (response?.success) {
      setMsg("Image delete successfully");
      setOpenSuccess(true);
      setSuccess(true);
      getProductDetails();
      setOpen(false);
      handleCloseUpdate();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong in delete image. Please try again later.");
    }
  };

  const handleChange = e => {
    const { name } = e.target;
    setAddImage({
      [name]: e.currentTarget?.files[0],
    });
    const files = Array.from(e.target.files);
    const imageUrls = files?.map(file => URL.createObjectURL(file));
    setImages([...imageUrls]);
  };

  const [openLoader, setOpenLoader] = useState(false);
  const [openBt, setOpenBt] = useState(false);
  const handleCloseBT = () => {
    setOpenBt(false);
  };

  const handleChangePublish = async e => {
    setOpenLoader(true);
    const { value } = e?.target;
    if (product?.productId) {
      let data = {
        basicDetail: {
          isActive: value == "false" ? false : true,
          productId: product.productId,
        },
      };
      const response = await productUpdateBasicDetailsApi(data);
      if (response?.success) {
        setMsg("Publish status update successfully");
        setOpenSuccess(true);
        setSuccess(true);
        getProductDetails();
      } else {
        setOpenSuccess(true);
        setSuccess(false);
        setMsg("Something went wrong. Please try again later.");
      }
    }
    setOpenLoader(false);
  };

  const deleteReview = async data => {
    let apiData = {
      isActive: false,
      productReviewId: data?.productReviewId,
    };
    const response = await productUpdateReviewApi(apiData);
    if (response?.success) {
      setMsg("Review Delete successfully");
      setOpenSuccess(true);
      setSuccess(true);
      getProductDetails();
    } else {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpenLoader(false);
  };

  const handleChangeTrending = async e => {
    setOpenLoader(true);
    const { value } = e?.target;
    if (product?.productId) {
      let data = {
        basicDetail: {
          trending: value == "false" ? false : true,
          productId: product.productId,
        },
      };
      const response = await productUpdateBasicDetailsApi(data);
      if (response?.success) {
        setMsg("Trending status update successfully");
        setOpenSuccess(true);
        setSuccess(true);
        getProductDetails();
      } else {
        setOpenSuccess(true);
        setSuccess(false);
        setMsg("Something went wrong. Please try again later.");
      }
    }
    setOpenLoader(false);
  };

  const DeleteProduct = async productId => {
    setOpenLoader(true);
    const params = {
      productId: productId,
    };
    const response = await deleteProductApi(params);
    if (response?.response?.data) {
      setMsg(response?.response?.data?.message);
      setOpenSuccess(true);
      setSuccess(false);
      return;
    }
    if (response?.success) {
      setTimeout(() => {
        setMsg("Product Delete Successfully");
        setOpenSuccess(true);
        setSuccess(true);
      }, [4000]);
      setTimeout(() => {
        navigate("/products");
      }, [7000]);
    }
    if (!response?.success) {
      setOpenSuccess(true);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };

  useEffect(() => {
    const activeColor = product?.colors?.find(color => color.isActive);
    if (activeColor) {
      setSelectedColor(activeColor.colorCode);
    }
  }, [product]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ padding: "32px", fontFamily: "Arial", position: "relative" }}>
        {/* Header Section */}
        <Grid container spacing={4}>
          <Grid style={{ height: "500px", position: "sticky", top: "90px" }} item xs={12} md={4}>
            {product?.images?.length > 0 && (
              <Swiper
                style={{
                  "--swiper-navigation-color": "#fff",
                  "--swiper-pagination-color": "#fff",
                  borderRadius: "10px",
                }}
                loop={true}
                spaceBetween={10}
                // navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Thumbs]}
                className='mySwiper2'
              >
                {product?.images.map((e, i) => (
                  <SwiperSlide style={{ position: "relative" }}>
                    <img src={e?.image} style={{ objectFit: "contain" }} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            {product?.images?.length == 0 && (
              <div
                style={{
                  border: "1px dashed gray",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  height: "100%",
                  borderRadius: "12px",
                  cursor: "pointer",
                }}
                onClick={() => handleClickOpen()}
              >
                <AddPhotoAlternateOutlinedIcon />
                <p>Add image</p>
              </div>
            )}
            <Swiper
              onSwiper={setThumbsSwiper}
              loop={true}
              spaceBetween={10}
              slidesPerView={4}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[FreeMode, Navigation, Thumbs]}
              className='mySwiper'
              style={{ overflowX: "scroll" }}
            >
              {product?.images?.map((e, i) => (
                <SwiperSlide style={{ cursor: "pointer", position: "relative" }}>
                  <div
                    style={{
                      position: "absolute",
                      right: "3px",
                      top: "3px",
                      color: "rgb(52, 71, 103)",
                    }}
                  >
                    <Tooltip title='Delete'>
                      <DeleteRounded
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          deleteImage(e);
                        }}
                      />
                    </Tooltip>
                    <Tooltip title='Update'>
                      <DriveFileRenameOutlineRoundedIcon
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickOpenUpdate(e);
                        }}
                      />
                    </Tooltip>
                  </div>
                  <img src={e?.image} style={{ objectFit: "contain" }} />
                </SwiperSlide>
              ))}
              {product?.images?.length > 0 && (
                <SwiperSlide style={{ border: "1px dashed gray", order: 99999 }}>
                  <label>
                    <div
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        width: "100%",
                        height: "100%",
                        gap: "6px",
                      }}
                      onClick={() => handleClickOpen()}
                    >
                      <AddPhotoAlternateOutlinedIcon />
                      <p style={{ fontSize: "12px", lineHeight: "14px" }}>Add image</p>
                    </div>
                  </label>
                </SwiperSlide>
              )}
            </Swiper>
          </Grid>

          {/* Product Information Section */}
          <Grid item xs={12} md={8}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
              <Typography sx={{ fontWeight: "500", marginBottom: "8px" }}>
                {product?.name}
              </Typography>
              <div
                style={{
                  display: "flex",
                  fontSize: "14px",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    cursor: "pointer",
                    textAlign: "right",
                    marginBottom: "8px",
                    color: "#344767",
                    fontWeight: 600,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "4px",
                    padding: "0 12px",
                    borderRadius: "6px",
                    backgroundColor: "white",
                    boxShadow: "0 0 2px 3px rgba(0,0,0,0.15)",
                  }}
                  onClick={() =>
                    navigate("/edit-product", { state: { productId: product?.productId } })
                  }
                >
                  <EditRounded />
                  Edit
                </div>
              </div>
            </div>
            <div>Brand: {product?.brand?.name}</div>

            <Grid
              container
              spacing={2}
              sx={{
                marginBottom: "16px",
                marginTop: "16px",
                padding: "12px",
                border: "1px solid #EBF0ED",
                background: "#FAFAFA",
                borderRadius: "16px",
              }}
            >
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  ₹{product?.price}
                </Typography>
                <Typography variant='caption'>Price</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  {product?.rating ? product?.rating : "---"}
                </Typography>
                <Typography variant='caption'>Rating</Typography>
              </Grid>
              <Grid
                item
                xs={3}
                style={{ padding: 0, textAlign: "center", borderRight: "1px solid #EBF0ED" }}
              >
                <Typography variant='h5' sx={{ fontWeight: "bold" }}>
                  {product?.reviews?.length > 0 ? product?.reviews?.length : "---"}
                </Typography>
                <Typography variant='caption'>Review Count</Typography>
              </Grid>
            </Grid>
            {/* Additional Information */}
            <Typography variant='h6' sx={{ fontWeight: "bold", marginTop: "24px" }}>
              Additional Information
            </Typography>
            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                marginTop: "10px",
                padding: "12px",
              }}
            >
              <div style={{ display: "flex", gap: "20px" }}>
                <div>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Publish Status
                  </Typography>
                  <div
                    style={{ display: "flex", gap: "8px", fontSize: "14px", alignItems: "center" }}
                  >
                    <div
                      style={
                        product?.isActive
                          ? {
                              borderRadius: "5px",
                              backgroundColor: "green",
                              width: "10px",
                              height: "10px",
                            }
                          : {
                              borderRadius: "5px",
                              backgroundColor: "red",
                              width: "10px",
                              height: "10px",
                            }
                      }
                    ></div>
                    <div>{product?.isActive ? "Published" : "Draft"}</div>
                    <Tooltip title={product?.isActive ? "Draft" : "Published"}>
                      <PublishSwitch
                        onChange={handleChangePublish}
                        value={!product?.isActive}
                        inputProps={{ "aria-label": "controlled" }}
                        checked={product?.isActive}
                      />
                    </Tooltip>
                    <Backdrop
                      sx={theme => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                      open={openLoader}
                    >
                      <CircularProgress color='inherit' />
                    </Backdrop>
                  </div>
                </div>
                <div>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Trending Status
                  </Typography>
                  <div
                    style={{ display: "flex", gap: "8px", fontSize: "14px", alignItems: "center" }}
                  >
                    <div
                      style={
                        product?.trending
                          ? {
                              borderRadius: "5px",
                              backgroundColor: "green",
                              width: "10px",
                              height: "10px",
                            }
                          : {
                              borderRadius: "5px",
                              backgroundColor: "red",
                              width: "10px",
                              height: "10px",
                            }
                      }
                    ></div>
                    <div>{product?.isActive ? "Trending" : "Draft"}</div>
                    <Tooltip title={product?.isActive ? "Draft" : "Trending"}>
                      <PublishSwitch
                        onChange={handleChangeTrending}
                        value={!product?.trending}
                        inputProps={{ "aria-label": "controlled" }}
                        checked={product?.trending}
                      />
                    </Tooltip>

                    {/* <div
                  style={
                    product?.trending
                      ? {
                          borderRadius: "5px",
                          backgroundColor: "green",
                          width: "10px",
                          height: "10px",
                        }
                      : {
                          borderRadius: "5px",
                          backgroundColor: "red",
                          width: "10px",
                          height: "10px",
                        }
                  }
                ></div>
                <div>{product?.trending ? "Yes" : "No"}</div>
                <PublishSwitch
                  onChange={handleChangeTrending}
                  value={!product?.trending}
                  inputProps={{ "aria-label": "controlled" }}
                  checked={product?.trending}
                /> */}
                    <Backdrop
                      sx={theme => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                      open={openLoader}
                    >
                      <CircularProgress color='inherit' />
                    </Backdrop>
                  </div>
                </div>
              </div>
            </Box>

            <FilterList
              filters={filters}
              productId={product?.productId}
              getProductDetails={getProductDetails}
            />

            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              <Grid item xs={12} md={12}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Characteristics
                  </Typography>
                  {product?.characteristics?.length == 0 && (
                    <Typography
                      style={{
                        fontSize: "12px",
                        color: "gray",
                      }}
                    >
                      Not yet!
                    </Typography>
                  )}
                  {product?.attributes?.map(e => (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e?.key}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        {e?.value}
                      </Typography>
                    </div>
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Descriptions
                  </Typography>
                  <Typography style={{ fontSize: "12px", color: "gray" }}>
                    {product?.description}
                  </Typography>
                </Box>
              </Grid>
            </div>
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              {/* Ratings Section */}
              <Grid item xs={12} md={6}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Ratings & Reviews
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <div
                      style={{
                        fontWeight: "bold",
                        backgroundColor:
                          product?.rating == 5 ? "green" : product?.rating >= 4 ? "blue" : "orange",
                        borderRadius: "6px",
                        fontSize: "16px",
                        color: "white",
                        padding: "4px 20px",
                      }}
                    >
                      {product?.rating}
                    </div>
                    <div>
                      {[1, 2, 3, 4].map(e => (
                        <Star
                          sx={{
                            color:
                              product?.rating == 5
                                ? "green"
                                : product?.rating >= 4
                                ? "blue"
                                : "orange",
                            padding: 0,
                            width: "12px",
                            height: "14px",
                          }}
                        />
                      ))}
                      {product?.reviews?.left > 0 && (
                        <div style={{ fontSize: "12px", marginTop: "-10px" }}>
                          Based on {product?.reviews?.length} Reviews
                        </div>
                      )}
                    </div>
                  </Box>
                  {/* Star Breakdown */}
                  {[5, 4, 3, 2, 1].map(star => (
                    <Box
                      key={star}
                      sx={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}
                    >
                      <Typography style={{ fontSize: "12px" }}>{star} Stars</Typography>
                      <Box
                        sx={{
                          flexGrow: 1,
                          height: "8px",
                          backgroundColor: "#ddd",
                          position: "relative",
                          borderRadius: "12px",
                        }}
                      >
                        <Box
                          sx={{
                            width: `${star * 20}%`,
                            backgroundColor: star === 5 ? "green" : star === 4 ? "blue" : "orange",
                            height: "100%",
                            borderRadius: "12px",
                          }}
                        ></Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Grid>
              {/* Reviews Section */}
              <Grid item xs={12} md={6}>
                <Box sx={{ border: "1px solid #ddd", borderRadius: "8px", padding: "12px" }}>
                  <Typography variant='h6' sx={{ fontWeight: "bold" }}>
                    Reviews{" "}
                    {product?.reviews?.length > 0 ? "(" + product?.reviews?.length + ")" : ""}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {product?.reviews?.length == 0 && (
                      <div style={{ fontSize: "14px" }}>No Review Yet!</div>
                    )}
                    {product?.reviews?.length > 0 &&
                      product?.reviews?.map(e => (
                        <div
                          style={{
                            boxShadow: "0 0 4px 1px rgba(0,0,0,0.1)",
                            borderRadius: "10px",
                            padding: "5px 10px",
                          }}
                        >
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Box sx={{ display: "flex", gap: "8px" }}>
                                  <Typography variant='subtitle1' style={{ fontSize: "14px" }}>
                                    {e?.name}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography variant='body2' sx={{ fontSize: "12px" }}>
                                {e?.review}
                              </Typography>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "end",
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Typography variant='caption'>
                                  {moment(e?.createdAt).format("ll")}
                                </Typography>
                              </div>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Tooltip title={"Edit"} style={{ cursor: "pointer" }}>
                                  <EditNoteRoundedIcon
                                    onClick={() => {
                                      handleClickOpenReview(e);
                                    }}
                                    style={{ padding: "1px", cursor: "pointer" }}
                                  />
                                </Tooltip>
                                <Tooltip
                                  title='Delete'
                                  style={{ cursor: "pointer", padding: "2px" }}
                                >
                                  <DeleteRounded onClick={() => deleteReview(e)} />
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </Box>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Box>
      <Footer />
      <AddImageDialog
        open={open}
        images={images}
        removeImage={removeImage}
        uploadImage={uploadImage}
        handleClose={handleClose}
        handleChange={handleChange}
      />
      <EditReviewForm
        open={reviewOpen}
        handleClose={handleCloseReview}
        handleSubmit={handleSubmitReview}
        updateReviewData={updateReviewData}
        handleChangeUpdateReview={handleChangeUpdateReview}
      />
      <UpdateImageDialog
        open={updateOpen}
        images={images}
        setImages={setImages}
        removeImage={removeImage}
        uploadImage={uploadImage}
        // deleteImage={deleteImage}
        handleClose={handleCloseUpdate}
        handleChange={handleChange}
        addImage={addImage}
        setAddImage={setAddImage}
        manageImageData={manageImageData}
      />
      <BoughtTogether
        open={openBt}
        handleClose={handleCloseBT}
        product={product}
        getProductDetails={getProductDetails}
      />
      <Success open={openSuccess} success={success} msg={msg} handleClose={handleCloseSuccess} />
    </DashboardLayout>
  );
};

export default ProductDetails;

const PublishSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  paddingRight: 0,
  gap: 0,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    height: 18,
    width: 38,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 18,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 9,
      marginTop: -1,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
      marginTop: -1,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
  },
}));
